<template>
    <div>
        <v-flex :class="`narrative-disclaimer grey--text darken-3 no-gutters mb-7`">
            We help candidates get elected in a lot of different ways. For the purposes of these statistics, we include candidates we’ve worked for directly or on behalf of, supported through independent expenditure campaigns, or targeted GOTV efforts. We used data from our Managed Service offering and our self-service platforms, <a href="https://www.dspolitical.com/deploy/" target="_blank">Deploy</a> and <a href="https://www.democraticads.com/" target="_blank">DemocraticAds.com</a>, in calculating these statistics.
        </v-flex>
    </div>
</template>

<script>
export default {
    name: "narrative-disclaimer",
}
</script>

<style lang="scss" scoped>
    .narrative-disclaimer {
        font-size: 12px;
        text-align: center;
    }
</style>